export default __webpack_public_path__ + "static/media/logo512.89b1e870.png";